/**
 * @generated SignedSource<<dfff04ed76657b520c7a03d6720bd8ed>>
 * @relayHash a4b44c4077246f8e7c4b202a8d2b77c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e8a1083218f4ae1925ebc7293cffe005d4c27fd510a81ec3ed29391dcca35855

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type VirtualAgentAiAnswersSrcQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type VirtualAgentAiAnswersSrcQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly key: string;
      readonly name: string;
      readonly virtualAgentConfiguration: {
        readonly __typename: string;
        readonly " $fragmentSpreads": FragmentRefs<"VirtualAgentAiAnswers731BadPattern">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"VirtualAgentAiAnswers" | "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef">;
    } | null;
  };
  readonly virtualAgent: {
    readonly virtualAgentEntitlements: {
      readonly " $fragmentSpreads": FragmentRefs<"VirtualAgentAiAnswers165BadPattern">;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef">;
};
export type VirtualAgentAiAnswersSrcQuery = {
  response: VirtualAgentAiAnswersSrcQuery$data;
  variables: VirtualAgentAiAnswersSrcQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import checkForAiEnabledFF_provider from '@jira/platform__graphql-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = [
  (v2/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = [
  (v8/*: any*/)
],
v10 = [
  {
    "kind": "ScalarField",
    "name": "isAiEnabledInAdminHub"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "VirtualAgentAiAnswersSrcQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v3/*: any*/),
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjectByKey",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef"
                },
                (v4/*: any*/),
                (v5/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "virtualAgentConfiguration",
                  "plural": false,
                  "selections": [
                    (v6/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "VirtualAgentAiAnswers731BadPattern"
                    }
                  ]
                },
                {
                  "kind": "FragmentSpread",
                  "name": "VirtualAgentAiAnswers"
                }
              ]
            }
          ]
        },
        "action": "THROW"
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "VirtualAgentQueryApi",
          "kind": "LinkedField",
          "name": "virtualAgent",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v7/*: any*/),
                "concreteType": "VirtualAgentFeatures",
                "kind": "LinkedField",
                "name": "virtualAgentEntitlements",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "VirtualAgentAiAnswers165BadPattern"
                  }
                ]
              },
              "action": "THROW"
            }
          ]
        },
        "action": "THROW"
      },
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "VirtualAgentAiAnswersSrcQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "virtualAgentConfiguration",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isAiResponsesEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "defaultJiraRequestTypeId"
                      }
                    ],
                    "type": "VirtualAgentConfiguration"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "VirtualAgentQueryError"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              (v4/*: any*/),
              {
                "args": (v7/*: any*/),
                "kind": "LinkedField",
                "name": "knowledgeBaseArticlesCount",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "count"
                      }
                    ],
                    "type": "KnowledgeBaseArticleCountSource"
                  }
                ]
              },
              (v8/*: any*/),
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "VirtualAgentFeatures",
            "kind": "LinkedField",
            "name": "virtualAgentEntitlements",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "VirtualAgentFeatures",
            "kind": "LinkedField",
            "name": "virtualAgentEntitlements",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isVirtualAgentAvailable"
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v10/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e8a1083218f4ae1925ebc7293cffe005d4c27fd510a81ec3ed29391dcca35855",
    "metadata": {},
    "name": "VirtualAgentAiAnswersSrcQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};
})();

(node as any).hash = "e474422ad56268d77b819344f295767a";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
